'use es6';

import { doBoundsIntersectMoreThanEdges } from 'layout-dnd-utils/geometry/basic';
const getIsValidTallestElement = (element, {
  invalidElements,
  ignorePositioning = false,
  viewportBounds
}) => {
  const computedStyle = window.getComputedStyle(element);
  const result = {
    isValid: true
  };
  if (computedStyle.overflow === 'hidden') {
    result.overflowHidden = true;
  }
  if (computedStyle.visibility === 'hidden' || computedStyle.opacity === '0') {
    result.isValid = false;
  }
  const hasValidPosition = ['static', 'relative'].indexOf(computedStyle.position) > -1;
  if (!hasValidPosition) {
    if (!ignorePositioning) {
      result.isValid = false;
    }
    result.isFixedPosition = true;
  }

  // If viewportBounds are passed, ignore height of elements that are not visible in the viewport
  if (result.isValid && viewportBounds) {
    const bounds = element.getBoundingClientRect();
    if (!doBoundsIntersectMoreThanEdges(bounds, viewportBounds)) {
      result.isValid = false;
    }
  }
  const isChildOfInvalidElement = invalidElements.some(e => e.contains(element));
  if (isChildOfInvalidElement) {
    result.isValid = false;
  }
  return result;
};

/**
 * Gets the height of the element, either using offsetHeight or
 * getBoundingClientRect depending on if we want to use fractional heights
 */
const getElementHeight = (el, shouldUseFractionalHeight) => {
  return shouldUseFractionalHeight ? el.getBoundingClientRect().height : el.offsetHeight;
};
export const getTallestElementHeight = (element, {
  ignorePositioning,
  shouldUseFractionalHeight,
  viewportBounds
} = {}) => {
  let tallestVisibleElement = element;
  const invalidElements = [];
  const fixedPositionElements = [];
  const allContainedElements = element.getElementsByTagName('*');
  for (let i = 0; i < allContainedElements.length; i++) {
    const el = allContainedElements[i];
    const tallestVisibleElementHeight = tallestVisibleElement ? getElementHeight(tallestVisibleElement, shouldUseFractionalHeight) : 0;
    const elementHeight = getElementHeight(el, shouldUseFractionalHeight);
    if (elementHeight > tallestVisibleElementHeight) {
      const elementData = getIsValidTallestElement(el, {
        invalidElements,
        ignorePositioning,
        viewportBounds
      });
      if (elementData.isValid) {
        tallestVisibleElement = el;
      }
      if (ignorePositioning && elementData.isFixedPosition) {
        fixedPositionElements.push(el);
      }
      if (!elementData.isValid || elementData.overflowHidden) {
        invalidElements.push(el);
      }
    }
  }
  // If we're including heights of fixed position elements, we should know if
  // the tallest height came from a fixed position element. This array will be empty
  // if we are not ignoring position styles.
  const isFixed = fixedPositionElements.some(e => e.contains(tallestVisibleElement));
  return {
    tallestHeight: tallestVisibleElement ? getElementHeight(tallestVisibleElement, shouldUseFractionalHeight) : 0,
    isFixed
  };
};